import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiEndpoints, baseQueryWithAuth } from "../../core";
import { ApiResponse, ISegment } from "../../types";

export const segmentApi = createApi({
  reducerPath: "segmentApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Segments"],

  endpoints: (builder) => ({
    getSegments: builder.query<ISegment[], void>({
      query: () => ({
        url: ApiEndpoints.segment,
        method: "GET",
        params: {
          limit: -1,
        },
      }),
      transformResponse: (res: ApiResponse<ISegment[]>) => {
        return res?.results ?? [];
      },
      providesTags: ["Segments"],
    }),

    getSegmentById: builder.query<ApiResponse<ISegment>, string>({
      query: (id) => ({
        url: `${ApiEndpoints.segment}/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, id) => [{ type: "Segments", id }],
    }),

    createSegment: builder.mutation<ApiResponse<ISegment>, Partial<ISegment>>({
      query: (data) => ({
        url: ApiEndpoints.createSegment,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Segments"],
    }),

    editSegment: builder.mutation<
      ApiResponse<ISegment>,
      { id: string; data: Partial<ISegment> }
    >({
      query: ({ id, data }) => ({
        url: `${ApiEndpoints.editSegment}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        "Segments",
        { type: "Segments", id },
      ],
    }),

    deleteSegment: builder.mutation<ApiResponse<void>, string>({
      query: (id) => ({
        url: `${ApiEndpoints.deleteSegment}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Segments"],
    }),
  }),
});

export const {
  useGetSegmentsQuery,
  useGetSegmentByIdQuery,
  useCreateSegmentMutation,
  useEditSegmentMutation,
  useDeleteSegmentMutation,
} = segmentApi;
